<script lang="ts">
	import ArrowBack from 'assets/svg/arrowBack.svg?component';
	import LocaleLink from 'components/LocaleLink/LocaleLink.svelte';
	import { _ } from 'svelte-i18n';

	export let text = $_('Back');
	export let to = '/';
</script>

<LocaleLink href={to} >
	<span class={`link-back ${$$props.class}`}>
		<ArrowBack />
		<span class="link-back-text">
			{text}
		</span>
	</span>
</LocaleLink>

<style lang="scss">
	@import 'linkBack';
</style>
